import { Container, Button, createTheme, MantineProvider } from "@mantine/core";
import { Paths } from "../../models/constants/paths";
import { useTranslation } from "react-i18next";
import { useMediaQuery } from "@mantine/hooks";
import "./SampleContractButton.scss";

export const SampleContractButton = () => {
    const { t } = useTranslation();
    const isMobile = useMediaQuery("(max-width: 1024px)", true, {
        getInitialValueInEffect: false,
    });

  const theme = createTheme({
    fontFamily: "Montserrat, sans-serif",
    colors: {
      "cba-legacy-green": [
        "#ebf7f6",
        "#d8f0ee",
        "#a4dbd6",
        "#76c4bc",
        "#2d9688",
        "#006b5b",
        "#00614e",
        "#004f3b",
        "#00402c",
      ],
    },
  });

  return (
    <MantineProvider theme={theme}>
        {isMobile 
        ? (
            <Button
            radius={4}
            component={"a"}
            target="_blank"
            href={Paths.TermsAndConditions}
            fullWidth
            variant="outline"
            color="#FF671D"
            className="sample-contract-button"
            >
            {t("view-sample-contract")}
            </Button>
        ) : (
            <Container size={"responsive"}>
            <Button
                radius={4}
                component={"a"}
                target="_blank"
                href={Paths.TermsAndConditions}
                variant="outline"
                color="#FF671D"
                className="sample-contract-button"
            >
                {t("view-sample-contract")}
            </Button>
            </Container>
        )}
    </MantineProvider>
  );
};
